/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as TYPES from './ActionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import {
  handleQuarterFormate,
  handleExistingCommentList,
  handleCommaSeparatedAmount,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';

export const setSuspendedCheckTab = (data) => {
  return { type: TYPES.SUSPENDED_CHECK_TAB_DATA, suspendedCheckTabObj: data };
};
export const handleErrorMessagesInRedux = (data) => ({
  type: TYPES.HANDLE_ERROR_MESSAGE_FOR_SUP_CHECK,
  errorMessagesInRedux: data,
});
export const dispatchGetSuspendedCheckLogGrid = (values) => {
  return {
    suspendedCheckLogGridList: values,
    type: TYPES.GET_SUSPENDED_CHECK_LOG_GRID_LIST,
  };
};
export const getSuspendedCheckLogGrid = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_SUSPENDED_CHECK_LOG_GRID_DETAILS, value)
    .then((response) => {
      return handleExistingCommentList(
        response.data?.suspendedCheckLogResponse,
        dispatch,
        dispatchGetSuspendedCheckLogGrid
      );
    })
    .catch(() => {
      dispatch(dispatchGetSuspendedCheckLogGrid([]));
    });
};

export const dispatchInvoiceGridList = (data) => {
  return {
    invoiceGridList: data,
    type: TYPES.GET_INVOICE_GRID_LIST,
  };
};
export const getInvoiceGridData = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_SUSPENDED_CHECK_MFG_GRID_DETAILS, value)
    .then((response) => {
      let tempObj = [];
      if (response.data?.suspendedChecksMfgResponse?.length > 0) {
        tempObj = response.data?.suspendedChecksMfgResponse?.map(
          (item, key) => {
            item.qtr = handleQuarterFormate(item.qtr);
            item.checkLogNum = value.checkLogNum;
            item.totInvoiceAmt = item.totInvoiceAmt
              ? handleCommaSeparatedAmount(item.totInvoiceAmt)
              : `$ ${parseFloat(0).toFixed(2)}`;
            item.index = key;
            return item;
          }
        );
      }
      return handleExistingCommentList(
        tempObj,
        dispatch,
        dispatchInvoiceGridList
      );
    })
    .catch(() => {
      dispatch(dispatchInvoiceGridList([]));
    });
};

export const dispatchReconciliationGridList = (data) => {
  return {
    reconciliationGridList: data,
    type: TYPES.GET_RECONCILIATION_GRID_LIST,
  };
};
export const getReconciliationGridData = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_INVOICE_GRID_DETAIL, value)
    .then((response) => {
      const tempObj = response.data?.suspendedChecksInvoiceResponseVO?.map(
        (item) => {
          item.invRecQtr = handleQuarterFormate(item.invRecQtr);
          item.invoiceNum = value?.invoiceNum;
          item.invRecSeqNum = value?.invRecSeqNum;
          item.principalPaidAmt = item.principalPaidAmt
            ? handleCommaSeparatedAmount(item.principalPaidAmt)
            : `$ ${parseFloat(0).toFixed(2)}`;
          item.interestPaidAmt = item.interestPaidAmt
            ? handleCommaSeparatedAmount(item.interestPaidAmt)
            : `$ ${parseFloat(0).toFixed(2)}`;
          return item;
        }
      );
      return dispatch(dispatchReconciliationGridList(tempObj));
    })
    .catch(() => {
      dispatch(dispatchReconciliationGridList([]));
    });
};
export const dispatchCreditBalConfirmation = (data) => {
  return {
    creditBalanceCount: data,
    type: TYPES.FETCH_CREDIT_BALANCE_COUNT,
  };
};
export const getCreditBalConfirmation = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_CREDIT_BALANCE_COUNT, value)
    .then((response) => {
      return dispatch(dispatchCreditBalConfirmation(response.data));
    })
    .catch(() => {
      dispatch(dispatchCreditBalConfirmation({}));
    });
};
export const dispatchUnallocatedBalance = (data) => {
  return {
    unallocatedBalance: data,
    type: TYPES.FETCH_UNALLOCATED_BALANCE,
  };
};
export const getUnallocatedBalance = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_UNALLOCATED_BALANCE, value)
    .then((response) => {
      return dispatch(dispatchUnallocatedBalance(response.data));
    })
    .catch(() => {
      dispatch(dispatchUnallocatedBalance({}));
    });
};
export const dispatchSaveOrUpdate = (values) => {
  return {
    saveOrUpdateMessage: values,
    type: TYPES.SAVE_OR_UPDATE_SUSPENDED_CHECKS,
  };
};
export const postSaveOrUpdate = (value) => (dispatch) => {
  if (value === null) {
    dispatch(dispatchSaveOrUpdate(null));
  } else {
    return axios
      .post(serviceEndPoint.SAVE_SUSPENDED_CHECKS, value)
      .then((response) => {
        return dispatch(dispatchSaveOrUpdate(response.data));
      })
      .catch(() => {
        dispatch(dispatchSaveOrUpdate('failed'));
      });
  }
};
export const clearReduxSuspendedCheckScreen = () => (dispatch) => {
  dispatch(setSuspendedCheckTab({}));
  dispatch(dispatchUnallocatedBalance({}));
  dispatch(dispatchGetSuspendedCheckLogGrid([]));
  dispatch(handleErrorMessagesInRedux([]));
  dispatch(dispatchSaveOrUpdate(''));
  dispatch(handleErrorMessagesInRedux([]));
  dispatch(dispatchInvoiceGridList([]));
  dispatch(dispatchReconciliationGridList([]));
  dispatch(dispatchCreditBalConfirmation({}));
};
